/* analytics.js - Phase 117.14
 *
 * Safe wrapper around `window.posthog.capture()`.
 *
 * Why a wrapper?
 *   1. PostHog is loaded asynchronously from `public/index.html`,
 *      so the global may not exist yet when a component fires its
 *      first event. We swallow that silently.
 *   2. Users who opted out via Settings → "Product analytics"
 *      (Phase 117.8) have `posthog.has_opted_out_capturing() === true`.
 *      Calling `capture()` while opted-out is a no-op in the SDK,
 *      but we guard anyway so the dev console stays clean.
 *   3. Ad-blockers / strict-privacy browsers (Brave, Firefox-strict)
 *      stub the global to {}. `typeof capture === 'function'` weeds
 *      those out before we attempt to call it.
 *
 * Usage:
 *   import { track } from '../lib/analytics';
 *   track('cost_calc_plan_change', { plan_id: 'iconic_plus' });
 */

export function track(eventName, properties = undefined) {
  if (typeof window === 'undefined') return;
  const ph = window.posthog;
  if (!ph || typeof ph.capture !== 'function') return;
  try {
    if (typeof ph.has_opted_out_capturing === 'function' && ph.has_opted_out_capturing()) {
      return;
    }
  } catch (_e) {
    // The SDK stub raises before the real lib loads; treat as
    // "not opted out" and continue.
  }
  try {
    ph.capture(eventName, properties);
  } catch (_e) {
    // Never let a tracking failure bubble into a user-facing crash.
  }
}
